<!--
正の数のとき: ▲
負の数のとき: ▼
-->
<template>
    <div>
        <div v-if="isPositive">
            ▲
        </div>
        <div v-else>
            ▼
        </div>
    </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
    props: {
        value: VueTypes.number.isRequried
    },
    computed: {
        isPositive () {
            return this.value > 0 ? true : false
        }
    }
}
</script>
